var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authMode)?_c('div',{staticClass:"border border-secondary rounded p-1 d-flex"},[_c('span',{staticClass:"m-auto text-light"},[_c('Icon',{attrs:{"name":"lock"}}),_vm._v(" "+_vm._s(_vm.authMode)+" ")],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }